import React, { forwardRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '@components/PrimaryButton';
import ArrowRight from '@components/Icons/ArrowRight';
import penguin from '@assets/penguin-banner.svg';
import { useStyles, useStylesButton } from './styles';
import SignIn from '../../../SignIn';
import VerificationCodeScreen from '../../../VerificationCodeScreen';
import { ROUTES } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../../hooks';

const TopRecommendBanner = forwardRef(
  ({ conditionDisplayingTopBanner, topBannerText }, topBannerRef) => {
    const classes = useStyles();
    const { t } = useTranslation(['auth', 'visitScreen', 'button']);
    const classesButton = useStylesButton();
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [open, setOpen] = useState(false);
    const [isVerificationScreen, updateIsVerificationScreen] = useState(false);
    const [nextScreen] = useState(ROUTES.SLIDER_SCREEN);
    const { session } = useAuthContext();

    const handleClose = async () => {
      setOpen(false);
      if (nextScreen === ROUTES.MENU_SCREEN) {
        history.push(nextScreen, {
          from: ROUTES.VISIT_SCREEN,
          data: {
            nextScreen,
          },
        });
      }
    };

    const CloseVerificationScreen = () => {
      updateIsVerificationScreen(false);

      if (nextScreen === ROUTES.MENU_SCREEN) {
        history.push(nextScreen, {
          from: ROUTES.VISIT_SCREEN,
          data: {
            nextScreen,
          },
        });
      }
    };

    const goToRecommendPage = () => {
      if (!session?.authenticated) {
        setOpen(true);
      } else {
        history.push('/slider-screen', { from: '/menu' });
      }
    };

    const OpenVerificationScreen = () => {
      updateIsVerificationScreen(true);
      setTimeout(() => {
        setOpen(false);
      }, 800);
    };
    const sessionString = localStorage.getItem('session');
    const sessionParsed = JSON.parse(sessionString);

    return (
      <div>
        <div
          ref={topBannerRef}
          onClick={goToRecommendPage}
          className={classes.banner}
          style={
            sessionParsed.visit.promoteProductsTestGroup !== 'a'
              ? {
                  marginTop: '2rem',
                }
              : {
                  marginTop: '0rem',
                }
          }
        >
          <div className={classes.logoTextPart}>
            <div className={classes.logoWrapper}>
              <img src={penguin} alt="penguin" className={classes.logoImg} />
            </div>
            <div className={classes.text}>Cocktail finder</div>
          </div>
          <PrimaryButton
            text={'help'}
            handleClick={goToRecommendPage}
            classesButton={classesButton}
            endIcon={<ArrowRight />}
          />
        </div>
        <SignIn
          open={open}
          screen={'visit'}
          handleClose={handleClose}
          OpenVerificationScreen={OpenVerificationScreen}
          root={nextScreen}
          email={email}
          title={t('signIn.title')}
          subTitle={t('signIn.subTitle')}
          setEmail={setEmail}
        />
        <VerificationCodeScreen
          isVerificationScreen={isVerificationScreen}
          handleClose={CloseVerificationScreen}
          email={email}
          nextScreen={nextScreen}
          root={nextScreen}
          setEmail={setEmail}
        />
      </div>
    );
  },
);

export default TopRecommendBanner;
